import { Injectable } from '@angular/core';

import { ModalDialogService } from '../../_shared/services/modal-dialog.service';
import { UtilService } from '../../_shared/services/util.service';

import { OccupancyType } from './occupancy-type.model';
import { OccupancyTypesModalComponent } from '../components/occupancy-types-modal/occupancy-types-modal.component';
import { OccupancyTypeModalComponent } from '../components/occupancy-type-modal/occupancy-type-modal.component';
import { OccupancyTypeTranslationModalComponent } from '../components/occupancy-type-translation-modal/occupancy-type-translation-modal.component';

@Injectable({
  providedIn: 'root',
})
export class OccupancyTypeModalService {
  constructor(private modalDialogService: ModalDialogService, private utilService: UtilService) {}

  openOccupancyTypesModal(successCallback) {
    const options = {
      width: '700px', // 1000px
      minHeight: '80vh',
      maxHeight: '80vh',
      position: { top: '5vh' },
      disableClose: true,
      data: {
        title: 'OCCUPANCY_TYPES',
      },
      confirmCallback: successCallback,
      // preventCloseOnSave: true,
    };

    this.modalDialogService.open(options, OccupancyTypesModalComponent);
  }

  openOccupancyTypeModal(
    occupancyType: OccupancyType,
    defaultLanguage,
    additionalLanguages,
    mode,
    successCallback = null
  ) {
    const confirmCallback = (result) => {
      // Edit
      if (occupancyType.id) {
        occupancyType.name = result.name;
        occupancyType.occupancy = result.occupancy;

        return this.utilService.changeItemRowStyle(occupancyType.id);
      }

      return successCallback(result);
    };

    const options = {
      disableClose: true,
      data: {
        title: 'OCCUPANCY_TYPE_DETAILS',
        obj: occupancyType,
        params: {
          defaultLanguage: defaultLanguage,
          additionalLanguages: additionalLanguages,
          mode: mode,
        },
      },
      confirmCallback: confirmCallback,
    };

    this.modalDialogService.open(options, OccupancyTypeModalComponent);
  }

  openOccupancyTypeTranslation(occupancyType: OccupancyType, language: any) {
    const options = {
      panelClass: 'dialog-sidepanel',
      position: { right: '0' },
      data: {
        title: 'OCCUPANCY_TYPE_DETAILS',
        obj: occupancyType,
        params: {
          language: language,
        },
      },
    };

    this.modalDialogService.open(options, OccupancyTypeTranslationModalComponent);
  }
}
